(function ( $ ) {
	$.fn.cityAutocomplete = function(zipCodeInput, cityNameInput, streetInput) {

		var $zipCodeInput=$(zipCodeInput);
		var $cityNameInput=$(cityNameInput);
		var $cityList=$('<ul class="city-autocomplete-list list-empty"></ul>').insertAfter($cityNameInput);
		//var scrollY = 0;

		var xhr;
		var cache=[];

		function selectOption(element){
			$cityNameInput.val(element.text());
			$cityNameInput.trigger('keyup');
			if(element.data('zipcode')!==""){
				$zipCodeInput.val(element.data('zipcode'));
			}
			hideOptionList();
			if(streetInput){
				$(streetInput).trigger('focus');
			}
		}
		function init() {
			$('body').one('click.cityAutocomplete',function(event){
				var isAutocompleteField = $(event.target).data('city-autocomplete')==true;
				if(!isAutocompleteField){
					clearOptionList();
					$('html').removeClass('city-autocomplete-active');
				}
			});
			$zipCodeInput.data('city-autocomplete',true).attr({
				spellcheck:"false",
				autocapitalize:"off",
				autocorrect:"off",
				autocomplete:"off"
			}).addClass('city-autocomplete-zipCode').on('keyup change', function(event){
				clearOptionList();
			}).on('focus', function(event){

			});
			$cityList.on('click', '.city-name-list-item', function(){
				selectOption($(this));
			});
			$cityNameInput.on('focusin', function () {
				this.select();
			});
			$cityNameInput.data('city-autocomplete',true).attr({
				spellcheck:"false",
				autocapitalize:"off",
				autocorrect:"off",
				autocomplete:"off"
			}).addClass('city-autocomplete-cityName').on('keydown focus paste', function(event){
				var key = event.keyCode,
					$listItems = $cityList.find('li:not(.city-name-list-item-hidden)');

				if($(this).val().length < 3 && !zipCodeIsCorrect()) {
					clearOptionList();
					return;
				}
				if(key>=37 && key<=40){
					return;
				}
				if(zipCodeIsCorrect() && typeof cache[$zipCodeInput.val()] !== "undefined" && $listItems.length) {
					filterList();
				}else {
					getList();
				}
			});
			if(streetInput){
				$.streetAutocomplete(zipCodeInput, cityNameInput, streetInput);
			}
		}
		function zipCodeIsCorrect() {
			var isValid = false;
			var digits = $zipCodeInput.val().replace(/\D/g, '');
			if(digits.length === 5) {
				isValid = true;
				digits = digits.slice(0,2) + '-' + digits.slice(2);
				$zipCodeInput.val(digits)
			}
			return isValid;
		}
		function clearOptionList() {
			$cityList.html('');
		}
		function getList() {
			abortAjax();
			var cacheElement=''+$cityNameInput.val()+$zipCodeInput.val();
			if(typeof cache[cacheElement] !== "undefined"){
				buildList(cache[cacheElement]);
			}else{
				$cityNameInput.addClass('city-autocomplete-loading');
				xhr = $.ajax({
					method: 'GET',
					contentType: 'application/json',
					dataType: 'text',
					url: '/citiesWithZipCode.ltr',
					data: {
						q: $cityNameInput.val(),
						zipCode: $zipCodeInput.val(),
						type: 'city',
					},
					success: function(response){
						response=JSON.parse(response);
						cache[cacheElement]=response;
						buildList(response);
					},
					complete: function() {
						$cityNameInput.removeClass('city-autocomplete-loading');
					}
				});
			}
		}
		function buildList(list) {
			clearOptionList();
			$.each(list, function(i, val) {
				$cityList.append($('<li>', { class:'city-name-list-item', text: val.city, 'data-zipcode': val.zipCode }));
			});
			if(list.length){
				showOptionList();
			}
		}
		function abortAjax() {
			if(xhr && xhr.readystate != 4){
				xhr.abort();
			}
			$cityNameInput.removeClass('city-autocomplete-loading');
			hideOptionList();
		}
		function filterList() {
			$cityList.find('.city-name-list-item').each(function(i, val){
				if(!$(this).text().trim().toLowerCase().startsWith($cityNameInput.val().toLowerCase())) {
					$(this).addClass('city-name-list-item-hidden');
				} else {
					$(this).removeClass('city-name-list-item-hidden');
					var val = $('#cityName').val();
					var text = $(this).text().trim();
					$(this).html(text.replace(new RegExp('(' + val + ')', 'gi'), '<b>$1</b>'));
				}
			});
			if($cityList.find('.city-name-list-item-hidden').length === $cityList.find('.city-name-list-item').length){
				hideOptionList();
			}
			else {
				showOptionList();
			}
		}
		function hideOptionList() {
			$cityList.addClass('list-empty');
			$('html').removeClass('city-autocomplete-active');
		}
		function showOptionList() {
			$cityList.removeClass('list-empty');
			$('html').addClass('city-autocomplete-active');
		}
		init();
	}
	$.fn.cityUnautocomplete = function unautocomplete(zipCodeInput, cityNameInput, streetInput) {
		let $zipCodeInput = $(zipCodeInput);
		let $cityNameInput = $(cityNameInput);
		let $cityList = $cityNameInput.next();

		// Detach all event handlers
		$zipCodeInput.off('keyup change focus');
		$cityNameInput.off('keydown focus paste');
		$cityList.off('click');

		// Remove attributes added by this plugin
		$zipCodeInput.removeData('city-autocomplete').removeClass('city-autocomplete-zipCode');
		$cityNameInput.removeData('city-autocomplete').removeClass('city-autocomplete-cityName');

		// Remove additional elements added by this plugin
		$cityList.remove();
		$('html').removeClass('city-autocomplete-active');

		if (streetInput) {
			$.streetUnautocomplete(streetInput);
		}
	}
	$.cityAutocomplete=$(window).cityAutocomplete;
	$.cityUnautocomplete=$(window).cityUnautocomplete;
}(jQuery));
